import { stringArrayToSelectOptions } from '@/utils/misc.ts'
import { SelectGroupOption } from '@/common/types/components.def.ts'

export const EmploymentStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
}
export const EmploymentStatusOptions = stringArrayToSelectOptions(Object.values(EmploymentStatus))

export const EmploymentType = {
  Permanent: 'Permanent',
  Contractor: 'Contractor',
  Intern: 'Intern',
}
export const EmploymentTypeOptions = stringArrayToSelectOptions(Object.values(EmploymentType))

export const EmployeeType = {
  FullTime: 'Full-Time',
  PartTime: 'Part-Time',
}
export const EmployeeTypeOptions = stringArrayToSelectOptions(Object.values(EmployeeType))

export const HiringType = {
  NewHire: 'New Hire',
  GroupTransferIn: 'Group Transfer In',
  Rehire: 'Rehire',
}
export const HiringTypeOptions = stringArrayToSelectOptions(Object.values(HiringType))

export const TerminationType = {
  Voluntary: 'Voluntary',
  Involuntary: 'Involuntary',
  Others: 'Others',
}
export const TerminationTypeOptions = stringArrayToSelectOptions(Object.values(TerminationType))

export const NSNCType = {
  NotApplicable: 'Not Applicable',
  AfterCessation: 'After Cessation',
  ReducedByGardenLeave: 'Reduced by Garden Leave',
}
export const NSNCTypeOptions = stringArrayToSelectOptions(Object.values(NSNCType))

export const TerminationReason = {
  Resignation: 'Resignation',
  ResignationDueToPerformance: 'Resignation due to Performance',
  Termination: 'Termination',
  Redundancy: 'Redundancy',
  DismissalDueToMisconduct: 'Dismissal due to Misconduct',
  EndOfContract: 'End of Contract',
  MutualAgreement: 'Mutual Agreement',
  GroupTransferOut: 'Group Transfer Out',
  Retirement: 'Retirement',
  Demise: 'Demise',
}
export const TerminationReasonTypeMap = {
  [TerminationType.Voluntary]: [TerminationReason.Resignation],
  [TerminationType.Involuntary]: [
    TerminationReason.ResignationDueToPerformance,
    TerminationReason.Termination,
    TerminationReason.Redundancy,
    TerminationReason.DismissalDueToMisconduct,
  ],
  [TerminationType.Others]: [
    TerminationReason.EndOfContract,
    TerminationReason.MutualAgreement,
    TerminationReason.GroupTransferOut,
    TerminationReason.Retirement,
    TerminationReason.Demise,
  ],
}
export const TerminationReasonOptions = Object.entries(TerminationReasonTypeMap).map(([key, value]) => {
  return {
    key,
    label: key,
    options: stringArrayToSelectOptions(value),
  } as SelectGroupOption
})

export const VoluntaryResignationReason = {
  Compensation: 'Compensation',
  BetterCareerOpportunity: 'Better career opportunity',
  CareerChange: 'Career change',
  Culture: 'Culture',
  FamilyOrPersonalReasons: 'Family or personal reasons',
  CareerAdvancementOrDevelopmentOpportunities: 'Career advancement or development opportunities',
  Others: 'Others',
}
export const VoluntaryResignationReasonOptions = stringArrayToSelectOptions(Object.values(VoluntaryResignationReason))


export const EmploymentUpdateReason = {
  ContractRenewal: 'Contract Renewal',
  ProbationExtension: 'Probation Extension',
  Promotion: 'Promotion',
  OfficeLocationChange: 'Office Location Change',
  EmploymentEntityChange: 'Employment Entity Change',
  DepartmentTransfer: 'Department Transfer',
  EmploymentTypeConversion: 'Employment Type Conversion',
}
export const EmploymentUpdateReasonOptions = stringArrayToSelectOptions(Object.values(EmploymentUpdateReason))

export const CountryCode: Record<string, string> = {
  'Australia': 'AU',
  'China': 'CN',
  'Hong Kong': 'HK',
  'India': 'IN',
  'Japan': 'JP',
  'Singapore': 'SG',
  'Korea': 'KR',
  'Taiwan': 'TW',
  'United Kingdom': 'GB',
  'United States': 'US',
}

export const EmploymentEntity = {
  'Australia': ['Polymer Capital Australia Pty Limited'],
  'China': ['PAG Investment Consulting (Beijing) Co. Ltd.', 'PAG (Shanghai) Investment Consulting Co. Ltd.'],
  'Hong Kong': ['Polymer Capital Management (HK) Ltd', 'Polymer Consulting Limited'],
  'Singapore': ['Polymer Capital Singapore Pte Ltd', 'PAG Investment Advisors Pte. Ltd.'],
  'Korea': ['PAG Consulting Korea Ltd'],
  'Taiwan': ['Polymer Capital Management (HK) Limited, Taiwan Representative Office', 'Polymer Systematic Taiwan Limited, Taiwan Branch'],
  'Japan': ['Polymer Capital Japan Ltd'],
  'United Kingdom': ['PAG Advisers LLP'],
  'United States': ['Polymer Capital Management (US) LLC'],
  'India': ['PAGAC Advisors India Private Limited'],
}
export const EmploymentEntityOptions: SelectGroupOption[] = Object.entries(EmploymentEntity).map(([country, entities]) => {
  return {
    label: country,
    options: entities.map(entity => {
      return {
        key: `${country}-${entity}`,
        label: entity,
        value: entity,
      }
    }),
  } as SelectGroupOption
})

// map employment entity to country
export const EmploymentEntityCountryMap = Object.entries(EmploymentEntity).reduce((acc, [country, entities]) => {
  const toAdd = entities.reduce((innerAcc, e) => ({ ...innerAcc, [e]: country }), {}) as Record<string, string>
  return {
    ...acc,
    ...toAdd,
  }
}, {}) as Record<string, string>
